import { GetParticipantsNumberInCategory } from './types/getParticipantsNumberInCategory.types'

export const getParticipantsNumberInCategory: GetParticipantsNumberInCategory = (
  participants,
  category
) => (
  +participants[category].number || 0
)
